import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from './supabase'
import profileImage from './img/Rectangle 6.png'

const HomePage = () => {
  const [data, setData] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await supabase.from('365_employees').select('*')
      if (error) {
        console.error('Error fetching data:', error.message)
      } else {
        setData(data)
      }
    }

    fetchData()
  }, [])

  return (
    <div className="home">
      <a href="https://365degreetotalmarketing.com/">
        <img src={profileImage} alt="Profile" className="logo" />
      </a>
      <ul>
        {data.map((item) => (
          <li key={item.id}>
            <Link to={`/${item.slug}`}>{item.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default HomePage
